import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  transferOrdersGridLabel: {
    defaultMessage: 'Transfer Orders',
    id: 'r99wNG',
    description: 'Transfer Orders page header',
  },
});
